import { render, staticRenderFns } from "./CombinedStep.vue?vue&type=template&id=b0c379a0"
import script from "./CombinedStep.vue?vue&type=script&lang=js"
export * from "./CombinedStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TlmCheckoutSubscriptionType: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmCheckout/Subscription/Type.vue').default,TlmCheckoutCustomerPermissionsFields: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmCheckout/Customer/PermissionsFields.vue').default,TlmCheckoutCustomerContactInfoFields: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmCheckout/Customer/ContactInfoFields.vue').default,TlmCheckoutContinueBtn: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmCheckout/TlmCheckoutContinueBtn.vue').default})
